import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import { forwardRef } from 'react'
import './badge.scss'

const classes = generateClassNames('badge', ['count'])

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  count?: React.ReactNode
  invisible?: boolean
  placement?:
    | 'bottom'
    | 'bottom-left'
    | 'bottom-right'
    | 'left'
    | 'right'
    | 'top'
    | 'top-left'
    | 'top-right'
}

const Badge = forwardRef(function Badge(
  props: BadgeProps,
  ref: React.ForwardedRef<HTMLSpanElement>
) {
  const {
    count,
    children,
    className,
    invisible,
    placement = 'top-right',
    ...other
  } = props

  return (
    <span
      ref={ref}
      className={clsx(
        classes.root,

        className
      )}
      {...other}
    >
      {children}
      <span
        className={clsx(
          classes.count,
          children && `${classes.count}--anchor`,
          children && `${classes.count}--${placement}`,
          invisible && `${classes.count}--invisible`
        )}
      >
        {count}
      </span>
    </span>
  )
})

export default Badge
